import { AdjustmentSessionKind } from "@redotech/crdb-enums/fulfillment/adjustment-session-kind";
import type { AdjustmentSessionSearchRow } from "./search-adjustment-sessions";

export const adjustmentSessionKindLabels: Record<
  AdjustmentSessionKind,
  string
> = {
  [AdjustmentSessionKind.Receive]: "Receive",
  [AdjustmentSessionKind.Count]: "Count",
  [AdjustmentSessionKind.Transfer]: "Transfer",
};

export const adjustmentSessionStatusLabels: Record<
  AdjustmentSessionSearchRow["status"],
  string
> = {
  in_progress: "In Progress",
  submitted: "Submitted",
  completed: "Completed",
  cancelled: "Cancelled",
  reversed: "Reversed",
};
